/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon } from '@els/els-react--button';

function DragNode({ node, addToBuilder }) {
  const [{ isDragging }, dragRef] = useDrag(
    {
      type: 'DragNode',
      item: { node, type: 'DragNode' },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    },
    [node]
  );

  return (
    <div className="query-builder-search-section__drag-node">
      <div
        className="query-builder-search-section__drag-node-content"
        onClick={(e) => e.currentTarget === e.target && addToBuilder(node)}
        onKeyDown={(e) => e.currentTarget === e.target && addToBuilder(node)}>
        <ButtonWithIcon
          type="link"
          id="layerIcon"
          linkIconSize="s"
          sprite={node.canExist && node.children && node.children.length > 1 ? 'Layers' : 'Layer'}
          onClick={(e) => addToBuilder(node) && e.stopPropagation()}>
          {node.displayName}
        </ButtonWithIcon>
        <div ref={dragRef} aria-live="polite">
          {isDragging && <span className="sr-only">{node.displayName} is dragging to querybuilder area</span>}
          <Flyout trigger="hover" flyout={<span aria-hidden="true">Drag field</span>} placement="bottom" theme="simple">
            <ButtonWithIcon
              id={`querybuilder-dragfield-${node.id}`}
              draggable
              className="cursor-move"
              onClick={(dragE) => dragE.stopPropagation()}
              linkIconSize="xxs"
              iconOnly
              type="borderless"
              aria-grabbed={isDragging}
              sprite="Drag"
              tabIndex="-1"
              a11y={{ name: 'Drag', description: 'Drag Querylet' }}>
              drag
            </ButtonWithIcon>
          </Flyout>
        </div>
      </div>
    </div>
  );
}

DragNode.propTypes = {
  node: PropTypes.object,
  addToBuilder: PropTypes.func,
};

export default DragNode;
